import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BlankCard from '../../../../components/ui/cards/BlankCard'
import UserProfileImage from './UserProfileImage'
import UserProfileNameForm from './UserProfileNameForm'
import UserProfileNameDisplay from './UserProfileNameDisplay'
import UserProfileCareerTargetForm from './UserProfileCareerTargetForm'
import UserProfileEducationTargetForm from './UserProfileEducationTargetForm'

class UserProfileBasicInfoSection extends Component {
  static propTypes = {
    currentUser: PropTypes.any.isRequired,
    onClickInterests: PropTypes.func,
  }
  constructor(props) {
    super(props)

    this.state = {
      showingNameForm: false,
    }

    this.toggleNameForm = nextState =>
      this.setState({ showingNameForm: nextState })

    this.handleTranslateCheck = () => {
      if(this.translate.checked) {
        document.getElementById('google_translate_element').style.visibility = 'visible'
        window.google.translate.TranslateElement(
          {pageLanguage: 'en', includedLanguages: 'es,hi', layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL},
          'google_translate_element'
        )

        // after log out and then login again, because of the div re-render google-translate elements are
        // not showing up. So, have to load the main script again.
        if(document.getElementById('google_translate_element').hasChildNodes() === false){
          const script = document.createElement('script')
          script.src = '//translate.google.com/translate_a/element.js'
          document.body.appendChild(script)

          setTimeout(() => {
            window.google.translate.TranslateElement(
              {pageLanguage: 'en', includedLanguages: 'es,hi', layout: window.google.translate.TranslateElement.InlineLayout.HORIZONTAL},
              'google_translate_element'
            )
          },1000)
        }
      }
      else {
        document.getElementById('google_translate_element').style.visibility = 'hidden'
      }
    }
  }

  componentDidMount() {
    const googleTranslateElem = document.getElementById('google_translate_element')
    if(googleTranslateElem && googleTranslateElem.style.visibility === 'visible') {
      this.translate.checked = true
    }
  }

  render() {
    const { currentUser, onClickInterests } = this.props
    const { showingNameForm } = this.state

    return (
      <div className="row">
        <div className="col-md-6 col-xl-5 offset-xl-1" style={{ marginTop: '10px' }}>
          <BlankCard delay={0.8}>
            <UserProfileImage />
          </BlankCard>
          {showingNameForm ? (
            <BlankCard delay={0.9} style={{ marginTop: '10px', marginBottom: '10px' }}>
              <UserProfileNameForm toggleNameForm={this.toggleNameForm} />
            </BlankCard>
          ) : (
            <BlankCard delay={1} style={{ marginTop: '10px' }}>
              <UserProfileNameDisplay
                loaderType="facebook"
                isLoading={!currentUser.user}
                user={currentUser.user}
                toggleNameForm={this.toggleNameForm}
              />
            </BlankCard>
          )}
        </div>
        <div className="col-xl-5 col-md-6">
          <BlankCard delay={1.2} style={{ marginTop: '10px' }}>
            <UserProfileCareerTargetForm />
          </BlankCard>
          <BlankCard delay={1.3} style={{ marginTop: '10px' }}>
            <UserProfileEducationTargetForm />
          </BlankCard>
          <BlankCard delay={1.5} style={{ marginTop: '10px' }}>
            <h4>
              <input ref={i => {this.translate = i}} type="checkbox" onChange={() => this.handleTranslateCheck()}/> Translate?
            </h4>
          </BlankCard>
          <BlankCard notCard delay={1.6}>
            <div>
              <div className="text-center">
                <button className="btn btn-primary" style={{width: 300, maxWidth: '100%'}}
                        id="updateInterestsBtn"
                        onClick={onClickInterests}>
                  Update Interests
                </button>
              </div>
            </div>
          </BlankCard>
        </div>
      </div>
    )
  }
}

export default UserProfileBasicInfoSection



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/UserProfileBasicInfoSection.js